import React, { useState } from 'react';
import { t } from '../i18n';
import CalendarImage from '../media/Calendar-noWords.png';
import FriendsImage from '../media/Friends-noWords.png';
import HomeScreenImage from '../media/HomeScreen-noWords.png';
import RepostGoogleCalendarImage from '../media/Repost-GoogleCalendar-noWords.png';

const About = () => {
  const [error] = useState('');

  return (
    <div className="container about-page">
      <h1>{t('aboutConceptTitle')}</h1>
      <p>{t('aboutCreatorIntroduction')}</p>
      <p>{t('aboutCreatorStory')}</p>
      <p>{t('aboutPlanningProblem')}</p>
      <p>{t('aboutDeveloperSolution')}</p>
      <p>{t('aboutWelcome')}</p>
      <p>{t('aboutCallToAction')}</p>

      <h1>{t('aboutTutorialTitle')}</h1>
      <h2>{t('calendar')}</h2>
      <p>{t('aboutCalendarCreateEvent')}</p>
      <div style={{ maxWidth: '500px' }}>
        <img src={CalendarImage} alt={t('calendar')} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
      </div>
      <p>{t('aboutEventColorsIntroduction')}</p>
      <ul>
        <li><strong>{t('aboutColorGold')}</strong> - {t('aboutColorGoldDescription')}</li>
        <li><strong>{t('aboutColorGreen')}</strong> - {t('aboutColorGreenDescription')}</li>
        <li><strong>{t('aboutColorOrange')}</strong> - {t('aboutColorOrangeDescription')}</li>
        <li><strong>{t('aboutColorBlue')}</strong> - {t('aboutColorBlueDescription')}</li>
        <li><strong>{t('aboutColorGray')}</strong> - {t('aboutColorGrayDescription')}</li>
      </ul>
      <p>{t('aboutCalendarEventDetails')}</p>

      <h2>{t('aboutFriendPageTitle')}</h2>
      <p>{t('aboutFriendPageDescription')}</p>
      <div style={{ maxWidth: '500px' }}>
        <img src={FriendsImage} alt={t('friends')} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
      </div>

      <h2>{t('aboutHomePageTitle')}</h2>
      <p>{t('aboutHomePageDescription')}</p>
      <div style={{ maxWidth: '500px' }}>
        <img src={HomeScreenImage} alt={t('home')} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
      </div>

      <h2>{t('aboutRepostScreenTitle')}</h2>
      <p>{t('aboutGoogleCalendarDescription')}</p>
      <div style={{ maxWidth: '500px' }}>
        <img src={RepostGoogleCalendarImage} alt={t('addToGoogleCalendar')} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
      </div>
      <p>{t('aboutRepostDescription')}</p>
    </div>
  );
};

export default About;


/*

Calendar

The Calendar Screen is also where you create a new event
On the Calendar Screen, events you are hosting are Golden, events you are going to are Green, the ones where you might attend are Orange, Blue is for events you haven't responded to, and Grayed out events are ones you've turned down.
Click on an event for more information and to respond to it.





Concept

Hey, I'm Crypt0, a rock climber and Run Into Me's creator.
I created this website because I am a social butterfly and, in between climbing two walls, I can't help talking to other climbers. This led to me having a few too many climbers' phone numbers stored in my contacts, and using too much of my off-time scheduling climbing sessions with my new friends, like an overbooked Hollywood agent. 
I got annoyed at having to plan these sessions and individually message my friends; I wished I could just let them all know simultaneously when and where I would be climbing without formally inviting them, so they could just drop by if they felt like RUN(NING) INTO ME.
That's when I remembered I happened to be a dev and could just make a solution myself.
So welcome to Run Into Me, a website to let your friends know when you are doing an activity that they can join in on, no pressure.
The next time you plan on doing an activity that you can do alone, but would be more fun together (cinema, running, climbing... taxes???), post it here for your friends to see!



Friend Page
To add a Friend, either enter their username, or give them your invite link / QR code



HomeScreen
Swipe through your friends upcoming events to let them know if you are coming using the Home Screen.



RepostScreen
To be sure not to miss an event, you can use this button to add it to your Google Calendar.
Once you've responded that you will come to a friend's event, you can Repost it to your friends. The invite will now appear on the calendar's of your friends who are not on the host's friend list.

*/